import { render } from "./add_term_dialog.vue?vue&type=template&id=ceff3436"
import script from "./add_term_dialog.vue?vue&type=script&lang=js"
export * from "./add_term_dialog.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./add_term_dialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__